import { useQuery } from '@tanstack/react-query';
import { fetchInScopeGroupsForProduct } from '../services/security-groups';
import type { SecurityGroupListResponse } from '../types/security-admin.types';

const GROUPS_PAGE_SIZE = 200; // security-service caps at 200; covers MAX_ATTACH in one page

export function useScopedSecurityGroupsForProductQuery(
  productId: string,
  parentDealerId: string | null,
  search: string,
) {
  const trimmed = search.trim();
  const effectiveSearch = trimmed.length >= 2 ? trimmed : undefined;

  return useQuery<SecurityGroupListResponse>({
    queryKey: ['security-admin', 'in-scope-groups', productId, effectiveSearch ?? ''],
    queryFn: () =>
      fetchInScopeGroupsForProduct(productId, {
        search: effectiveSearch,
        per_page: GROUPS_PAGE_SIZE,
      }),
    // Disabled when the product has no owner dealer — the modal renders the
    // null-owner empty-state and fires no request (server is still authoritative).
    enabled: Boolean(parentDealerId) && Boolean(productId),
    staleTime: 2 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
